import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { showLabel: String, hideLabel: String }

  connect() {
    this.enhance()
    this.observer = new MutationObserver(() => this.enhance())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  enhance() {
    this.element.querySelectorAll('input[type="password"]').forEach((input) => {
      if (input.dataset.passwordVisibilityReady) return

      const wrapper = document.createElement("div")
      wrapper.className = "relative w-full min-w-0"
      input.parentNode.insertBefore(wrapper, input)
      wrapper.appendChild(input)
      input.classList.add("w-full", "min-w-0", "pr-10")

      const button = document.createElement("button")
      button.type = "button"
      button.className = "absolute right-1 top-1/2 inline-flex h-8 w-8 -translate-y-1/2 items-center justify-center text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
      button.addEventListener("click", () => this.toggle(input, button))
      wrapper.appendChild(button)
      input.dataset.passwordVisibilityReady = "true"
      this.updateButton(input, button)
    })
  }

  toggle(input, button) {
    input.type = input.type === "password" ? "text" : "password"
    this.updateButton(input, button)
  }

  updateButton(input, button) {
    const visible = input.type === "text"
    button.setAttribute("aria-label", visible ? this.hideLabelValue : this.showLabelValue)
    button.innerHTML = visible ? this.eyeOffIcon() : this.eyeIcon()
  }

  eyeIcon() {
    return '<svg aria-hidden="true" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"/><circle cx="12" cy="12" r="2.5" stroke-width="1.8"/></svg>'
  }

  eyeOffIcon() {
    return '<svg aria-hidden="true" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="m3 3 18 18M10.6 6.2A10.8 10.8 0 0 1 12 6c6 0 9.5 6 9.5 6a17.8 17.8 0 0 1-3.1 3.8M6.2 6.9C3.8 8.4 2.5 12 2.5 12s3.5 6 9.5 6c1 0 1.9-.2 2.7-.5"/></svg>'
  }
}
